<script setup lang="ts">

import {computed} from "vue";

const props = defineProps({
    demandIndicatorLevel: {
        type: Number,
        required: true
    },
})

const level = computed(() => props.demandIndicatorLevel)

</script>

<template>
    <div class="bars">
        <div class="bar" :class="{active: level >= 3}"></div>
        <div class="bar" :class="{active: level >= 2}"></div>
        <div class="bar" :class="{active: level >= 1}"></div>
    </div>
</template>

<style lang="scss" scoped>
    .bars {
        display: flex;
        flex-direction: column;

        .bar {
            width: 100%;
            margin: 3%;
            height: 30%;
            background-color: var(--ion-color-grey-tint-2);

            &.active {
                background-color: var(--ion-color-red);
            }

            &:first-child {
                border-radius: 3px 3px 0 0;
            }

            &:last-child {
                border-radius: 0 0 3px 3px;
            }
        }
    }
</style>
